import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Phone, Mail, ArrowRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-primary/20 pt-20 pb-10 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50"></div>
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1: Company Info */}
          <div data-aos="fade-up" data-aos-delay="0">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/logo.png"
                alt="TOTO INFRA Logo"
                className="h-10 w-auto object-contain"
              />
              <span className="text-2xl font-serif font-bold text-primary tracking-wider">TOTO INFRA</span>
            </div>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              A leader in specialized infrastructure, delivering excellence in steel plants, power plants, and turnkey civil construction with uncompromising quality and safety.
            </p>
            <div className="flex gap-4">
              {[Facebook, Twitter, Linkedin, Instagram].map((Icon, index) => (
                <a key={index} href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-all duration-300 hover:scale-110">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-aos="fade-up" data-aos-delay="100">
            <h4 className="text-xl font-serif font-semibold text-primary mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About Us', 'Our Projects', 'Services', 'Plant & Equipment', 'HSE & Safety', 'Careers'].map((item) => (
                <li key={item}>
                  <Link to="/" className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div data-aos="fade-up" data-aos-delay="200">
            <h4 className="text-xl font-serif font-semibold text-primary mb-6">Our Services</h4>
            <ul className="space-y-3">
              {['Steel Plant Construction', 'Power Plant Civil Works', 'Post Tensioning', 'Piling & Foundations', 'RMC Solutions', 'Turnkey Projects'].map((item) => (
                <li key={item}>
                  <Link to="/services" className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 group">
                    <ArrowRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-primary" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-aos="fade-up" data-aos-delay="300">
            <h4 className="text-xl font-serif font-semibold text-primary mb-6">Contact Us</h4>
            <ul className="space-y-6">
              <li className="flex items-start gap-4">
                <MapPin className="text-primary shrink-0 mt-1" size={20} />
                <span className="text-muted-foreground">
                  Head Office: D3/D4 – Dolphin Garden, Opp. Su-Swagat Hotel, Poonam Sagar, Mira Road East, Mumbai – 401107.
                </span>
              </li>
              <li className="flex items-center gap-4">
                <Phone className="text-primary shrink-0" size={20} />
                <div className="flex flex-col">
                  <a href="tel:+917030132885" className="text-muted-foreground hover:text-primary transition-colors">7030132885</a>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <Mail className="text-primary shrink-0" size={20} />
                <a href="mailto:sandhya@totoinfra.com" className="text-muted-foreground hover:text-primary transition-colors">sandhya@totoinfra.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} TOTO INFRA. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-primary transition-colors">Terms & Conditions</Link>
          </div>
          <p className="text-xs text-white/20 uppercase tracking-widest">Designed for Excellence</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
